!((document, Drupal, $, debounce) => {
  'use strict';
  Drupal.behaviors.accordion = {
    attach: function(context) {
      const behavior = this;
      // This is a wrapper method for this behavior's doAttach method. It is a
      // workaround to ensure that the logic only runs once per page load. When
      // BigPipe is enabled, comparing context to document is not an effective
      // way to prevent the behavior from attaching multiple times.
      // @link https://www.drupal.org/project/drupal/issues/3320055
      if (context === document) {
        once('accordion', '.accordion', context).forEach((_, index) => {
          if (index === 0) {
            behavior.doAttach(context);
          }
        });
      }
    },

    doAttach: function(context) {
      const accordions = $('.accordion');
      if (accordions.length === 0) {
        return;
      }

      const $headerContainer = $('.header', context);
      const $adminToolbar = $('#toolbar-bar', context);
      const $envIndicator = $('#environment-indicator', context);
      const $alertMessage = $('header .alert-message', context);
      const $mobileHeader = $('.header__col-left', context);

      $(document).ready(function() {
        let adminHeight =
          $adminToolbar.length > 0 ? $adminToolbar.outerHeight() : 0;
        let envHeight =
          $envIndicator.length > 0 ? $envIndicator.outerHeight() : 0;
        let alertHeight =
          $alertMessage.length > 0 && !$alertMessage.hasClass('dismissed')
            ? $alertMessage.outerHeight()
            : 0;
        let mobileHeaderHeight =
          $mobileHeader.length > 0 ? $mobileHeader.outerHeight() : 0;
        let desktopHeaderHeight =
          $headerContainer.length > 0 ? $headerContainer.outerHeight() : 0;

        // Create empty variables to use later for calculating heights.
        let $combinedHeights = 0;

        /**
         * @returns {any} Calculates Height
         */
        function combineHeights() {
          adminHeight =
            $adminToolbar.length > 0 ? $adminToolbar.outerHeight() : 0;

          if ($envIndicator.length > 0) {
            if (
              adminHeight >
              $envIndicator.offset().top - $(window).scrollTop()
            ) {
              envHeight = 0;
            }
            else {
              envHeight = $envIndicator.outerHeight();
            }
          }
          else {
            envHeight = 0;
          }
          alertHeight =
            $alertMessage.length > 0 && !$alertMessage.hasClass('dismissed')
              ? $alertMessage.outerHeight()
              : 0;
          mobileHeaderHeight =
            $mobileHeader.length > 0 ? $mobileHeader.outerHeight() : 0;
          desktopHeaderHeight =
            $headerContainer.length > 0 ? $headerContainer.outerHeight() : 0;

          if ($(window).innerWidth() > 1199) {
            $combinedHeights =
              desktopHeaderHeight + adminHeight + alertHeight + envHeight;
          }
          else {
            $combinedHeights =
              mobileHeaderHeight + adminHeight + alertHeight + envHeight;
          }
        }

        // Updates button aria-attribute
        const buttonAriaUpdate = (container) => {
          if (container.hasClass('accordion__container--column')) {
            if ($(window).outerWidth() > 768) {
              const $desktopBody = container.find(
                '.accordion__body--columnn-desktop'
              );

              $($desktopBody.siblings()[0]).removeAttr('aria-controls');
              $($desktopBody.siblings()[0]).attr(
                'aria-controls',
                $desktopBody.attr('id')
              );
            }
            else {
              const $mobileBody = container.find(
                '.accordion__body--columnn-mobile'
              );

              $($mobileBody.siblings()[0]).removeAttr('aria-controls');
              $($mobileBody.siblings()[0]).attr(
                'aria-controls',
                $mobileBody.attr('id')
              );
            }
          }
        };

        combineHeights();

        const openAccordion = (container, bodyWrapper, toggle, accordion) => {
          let $contentBody;

          if (container.hasClass('accordion__container--column')) {
            if ($(window).outerWidth() > 768) {
              $contentBody = container.find(
                '.accordion__body--columnn-desktop'
              );
            }
            else {
              $contentBody = container.find('.accordion__body--columnn-mobile');
            }
          }
          else {
            $contentBody = container.find('.accordion__body');
          }

          const $caretToggle = container.find('.accordion__toggle');
          const openedAccordion = $('.accordion__container.is-open', accordion);

          if (openedAccordion) {
            const openedAccordionBodyWrapper = $(
              '.accordion__body-wrapper',
              openedAccordion
            );
            const openedAccordionBody = $('.accordion__body', openedAccordion);
            const openedAccordionToggle = $(
              '.accordion__toggle',
              openedAccordion
            );

            openedAccordion.removeClass('is-open');
            openedAccordionToggle.removeClass('is-open');
            openedAccordionBody.hide();
            openedAccordionBodyWrapper.attr('aria-hidden', true);
            openedAccordionToggle.attr('aria-expanded', false);
          }

          container.addClass('is-open');
          $(toggle).addClass('is-open');
          $contentBody.show();
          bodyWrapper.removeAttr('aria-hidden');
          $(toggle).attr('aria-expanded', true);

          setTimeout(() => {
            $('body, html').animate(
              {
                scrollTop: $($caretToggle).offset().top - $combinedHeights - 50
              },
              600
            );
          }, 500);
        };

        const closeAccordion = (container, bodyWrapper, toggle) => {
          const $contentBody = container.find('.accordion__body');

          $contentBody.hide();
          container.removeClass('is-open');
          $(toggle).removeClass('is-open');
          bodyWrapper.attr('aria-hidden', true);
          $(toggle).attr('aria-expanded', false);
        };

        $.each(accordions, function(index, accordion) {
          let activeItemIndex = accordion.getAttribute('active-index');
          const list = Array.from($('.accordion__list-item', accordion));
          if (list.length > 0) {
            $.each(list, function(index, item) {
              const container = $('.accordion__container', item);
              const toggles = $('.accordion__toggle', item);
              const bodyWrapper = $('.accordion__body-wrapper', item);

              buttonAriaUpdate(container);

              $.each(toggles, function(index, toggle) {
                $(toggle).click(function() {
                  $(window).resize(function() {
                    closeAccordion(container, bodyWrapper, toggle);
                  });
                  if (container.hasClass('is-open')) {
                    closeAccordion(container, bodyWrapper, toggle);
                  }
                  else {
                    openAccordion(container, bodyWrapper, toggle, accordion);
                  }
                });
              });
              if (activeItemIndex) {
                activeItemIndex = parseInt(activeItemIndex);
                if (activeItemIndex === index) {
                  openAccordion(container, bodyWrapper, toggles[0], accordion);
                }
              }

              $(window).resize(function() {
                debounce(buttonAriaUpdate(container), 100, false);
              });
            });
          }
        });
      });
    }
  };
})(document, Drupal, jQuery, Drupal.debounce);
